import { initializeAppearance } from '../components/Appearance';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { router } from './router';
import { I18nProvider } from './lib/i18n';
import './styles.css';
import '../components/experience.css';

initializeAppearance();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider>
      <RouterProvider router={router} />
    </I18nProvider>
  </StrictMode>,
);

